import { type PageRequest } from "@client/types";

export const GET_COMMENTS_PAGE_ARGS: PageRequest = {
  page: 1,
  size: 20,
  order: "desc",
  sortBy: "CreatedOnDate"
};
